import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, sub, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <p className="font-mono text-xs uppercase tracking-[0.25em] text-blaze font-semibold">{overline}</p>
    <h2 className="mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight leading-tight text-slate-50">
      {title}
    </h2>
    {sub && <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">{sub}</p>}
  </Reveal>
);
